import { useEffect, useState } from 'react';
import { useDispatch } from 'redux/DappProviderContext';
import { initializeNetworkConfig } from 'redux/slices/networkConfigSlice';
import { NetworkConfigType } from 'types';

export function AppInitializer({
  networkConfig,
  children
}: {
  networkConfig: NetworkConfigType;
  children: any;
}) {
  const [initialized, setInitialized] = useState(false);
  const dispatch = useDispatch();

  async function initializeApp() {
    dispatch(initializeNetworkConfig(networkConfig));
    setInitialized(true);
  }
  useEffect(() => {
    initializeApp();
  }, [networkConfig]);

  return initialized ? children : null;
}

export default AppInitializer;
